/** My Applications constants */
export const APP_NAME_MAX_LENGTH = 80;
export const MAXIMUM_CALLBACK_URLS = 64;

/** Terms and passthrough billing links */
export const APS_TERMS_URL =
  "https://www.autodesk.com/company/legal-notices-trademarks/terms-of-service-autodesk360-web-services/forge-platform-web-services-api-terms-of-service";
export const ABOUT_PASSTHROUGH_BILLING_URL =
  "https://aps.autodesk.com/blog/introducing-passthrough-billing-more-flexible-way-manage-api-usage-costs-aps";
export const PASSTHROUGH_SETUP_GUIDE_URL =
  "https://aps.autodesk.com/blog/passthrough-billing-guide-isvs";

/** Teams constants */
export const TEAMS_INFO_URL =
  "https://www.autodesk.com/support/account/admin/users/manage-teams";

/** Miscellaneous */
export const MONETIZATION_LAUNCH_DATE_ISO = "2025-12-07";

export const PKCE_UNAUTHENTICATED_REDIRECT_PATH =
  "/myaccount/pkce-unauthenticated-redirect/";

/** Keep in sync with forge-unified-ui/src/pages/common/entry.js */
export const QUALTRICS_FEEDBACK_OPEN_EVENT = "qualtrics-feedback-open";
export const QUALTRICS_FEEDBACK_CLOSED_EVENT = "qualtrics-feedback-closed";
